import React, {Component} from 'react';
import t from 'tcomb-form';
import PropTypes from 'prop-types';

import {FullString} from 'js/tcomb_types';

import Button from 'js/components/button';
import FormInput from 'js/components/form_input';
import FormCheckboxLegacy from 'js/components/form_checkbox_legacy';
import PinterestButton from 'js/components/pinterest_button';
import Section from 'js/components/section';
import ButtonGroup from 'js/components/button_group';

import './index.scss';

export default class PinterestBoardForm extends Component {
    static propTypes = {
        onCreate: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        name: PropTypes.string,
        isSecret: PropTypes.bool
    };

    static defaultProps = {
        isSecret: false
    };

    constructor(props) {
        super(props);
        this.state = {
            name: props.name,
            isSecret: props.isSecret
        };
    }

    isValid() {
        const result = t.validate(this.state.name, FullString);
        return result.isValid();
    }

    render() {
        const {onCreate, onCancel} = this.props;
        const {name, isSecret} = this.state;

        return (
            <Section header="Name your Board">
                <FormInput
                    label="Name"
                    placeholder="Please enter the name of the new board"
                    value={name}
                    onChange={e => this.setState({name: e.target.value})}
                    required
                />
                <FormCheckboxLegacy
                    label="Create as private board"
                    onChange={e => this.setState({isSecret: !isSecret})}
                    checked={isSecret}
                    inline
                />
                <ButtonGroup className="pinterest-board-form__button-row">
                    <Button secondary mini back onClick={onCancel}>
                        Back
                    </Button>
                    <PinterestButton
                        onClick={() => onCreate(this.state)}
                        disabled={!this.isValid()}
                    >
                        Create Board
                    </PinterestButton>
                </ButtonGroup>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./components/pinterest_board_form/index.js